import { combineReducers } from "redux";
import authReducer from "./authReducer";
import userReducer from "./userReducer";
import companyReducer from "./companyReducer";
import employeeReducer from "./employeeReducer";
import companyEmployeeReducer from "./companyEmployeeReducer";
import shiftTypeReducer from "./shiftTypeReducer";
import projectReducer from "./projectReducer";
import shiftReducer from "./shiftReducer";
import companyEmployeeShiftReducer from "./companyEmployeeShiftReducer";
import shiftTypeCompanyReducer from "./shiftTypeCompanyReducer";

export default combineReducers({
  auth: authReducer,
  user: userReducer,
  company: companyReducer,
  employee: employeeReducer,
  companyEmployee: companyEmployeeReducer,
  shifttype: shiftTypeReducer,
  project: projectReducer,
  shift: shiftReducer,
  companyEmployeeShift: companyEmployeeShiftReducer,
  shiftTypeCompany: shiftTypeCompanyReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js